import classNames from 'classnames'
import { FC } from 'react'
import {
  BrandDashboard,
  ValueDelta,
} from 'src/services/aiListeningApi/brandProfile.types'
import { DeltaBadge, deltaTone } from './DeltaBadge'
import styles from './dashboard.module.scss'
import { formatPosition, formatRate } from '../utils'

interface Tile extends ValueDelta {
  isPosition?: boolean
  key: string
  title: string
}

interface KpiTilesProps {
  kpis: BrandDashboard['kpis']
}

export const KpiTiles: FC<KpiTilesProps> = ({ kpis }) => {
  const tiles: Tile[] = [
    { key: 'mentionRate', title: 'Mention Rate', ...kpis.mentionRate },
    {
      key: 'recommendationRate',
      title: 'Recommendation Rate',
      ...kpis.recommendationRate,
    },
    { key: 'promptWinRate', title: 'Prompt Win Rate', ...kpis.promptWinRate },
    {
      isPosition: true,
      key: 'avgPosition',
      title: 'Avg. AI Position',
      ...kpis.avgPosition,
    },
    {
      key: 'ownedCitationRate',
      title: 'Owned Citation Rate',
      ...kpis.ownedCitationRate,
    },
  ]

  return (
    <div className={styles.kpis}>
      {tiles.map((tile) => {
        const kind = tile.isPosition ? 'position' : 'points'
        const tone = deltaTone(tile.delta, kind)
        return (
          <div className={styles.kpi} key={tile.key}>
            <span className={styles.kpiTitle}>{tile.title}</span>
            <div className={styles.kpiRow}>
              <span className={styles.kpiValue}>
                {tile.isPosition
                  ? formatPosition(tile.value)
                  : formatRate(tile.value)}
              </span>
              {tone && (
                <span className={styles.kpiDelta}>
                  <DeltaBadge kind={kind} value={tile.delta} />
                  {/* Coloured like the badge: green, orange or grey. */}
                  <span
                    className={classNames(
                      styles.kpiCaption,
                      styles[`kpiCaption_${tone}`]
                    )}
                  >
                    vs previous period
                  </span>
                </span>
              )}
            </div>
          </div>
        )
      })}
    </div>
  )
}
